import React from 'react'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import Button from '../../../../../components/Button'
import FormRow from '../../../../../components/FormFields/FormRow'
import CheckboxField from '../../../../../components/FormFields/CheckboxField'
import SelectField from '../../../../../components/FormFields/SelectField'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'
import {
  legalFormsQuestAuditory,
  legalFormsQuestDeclareModel200,
  legalFormQuestPeriodTax,
  isCanarian
} from '../utils'

import { getApplyToStepPath } from '../../../../MainRoutes/utils'
import { stepStatuses } from '../../../constants'
import { StatusSteps } from '../../StatusSteps'

function DocumentsInfoForm({
  application,
  values,
  status = {},
  errors,
  touched,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <form onSubmit={handleSubmit}>
      {legalFormsQuestAuditory.includes(application.data.legal_form) && (
        <FormRow>
          <CheckboxField
            type='checkbox'
            name='must_declare_auditory'
            value={values.must_declare_auditory}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('must_declare_auditory', { errors, touched })}
            help={renderValidation('must_declare_auditory', { errors, touched })}
            label='Tengo obligación de declarar auditorías'
          />
        </FormRow>
      )}
      {legalFormsQuestDeclareModel200.includes(application.data.legal_form) && (
        <FormRow>
          <CheckboxField
            type='checkbox'
            name='require_model200'
            value={values.require_model200}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('require_model200', { errors, touched })}
            help={renderValidation('require_model200', { errors, touched })}
            label='Tengo obligación de presentar el modelo 200'
          />
        </FormRow>
      )}
      {isCanarian(application.data.zip_code) && (
        <FormRow>
          <SelectField
            name='igic'
            value={values.igic}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('igic', { errors, touched })}
            help={renderValidation('igic', { errors, touched })}
            label='Tipo de declaración de impuestos'
            full
          >
            <option value='' />
            <option value='igic'>IGIC</option>
            <option value='iva'>IVA</option>
            <option value='both'>Ambos</option>
          </SelectField>
        </FormRow>
      )}
      {legalFormQuestPeriodTax.includes(application.data.legal_form) && (
        <FormRow>
          <SelectField
            name='period_tax'
            value={values.period_tax}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('period_tax', { errors, touched })}
            help={renderValidation('period_tax', { errors, touched })}
            label='Periodicidad de declaración de impuestos'
            full
          >
            <option value='' />
            <option value='trimestral'>Trimestral</option>
            <option value='mensual'>Mensual</option>
          </SelectField>
        </FormRow>
      )}
      {status.error && (
        <FormError>
          <FormattedMessage {...getExceptionMessage(status.error)} />
        </FormError>
      )}
      <FormActions>
        <Button type='submit' disabled={isSubmitting}>Continuar</Button>
        <Link to={getApplyToStepPath(stepStatuses.FINANCIAL, application)}>Volver</Link>
      </FormActions>
      <StatusSteps />
    </form>
  )
}

export default DocumentsInfoForm
